import RestResource from '../rest.service';

export default class QuotationPicturesService extends RestResource {
  constructor() {
    super('quotation-pictures');
  }
}
